import { CheckOutlined, CloseOutlined, DownloadOutlined } from '@ant-design/icons';
import { PaginationProps } from 'antd';
import TextArea from 'antd/es/input/TextArea';
import dayjs from 'dayjs';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { addCustomerByGroup, addListGroup, getListAllCustomer, getListCustomerByGroup } from '../../../../../api/groupCustomerV2/groupCustomerV2Api';
import { group_share, group_share_active, user_private, user_private_active } from '../../../../../components/ExportImgFigma';
import useDebounce from '../../../../../hook/useDebounce';
import useLoading from '../../../../../hook/useLoading';
import useThrottle from '../../../../../hook/useThrottle';
import useToast from '../../../../../hook/useToast';
import { EDisplayGroupType, useCustomerGroupContext } from '../../indexV2';
import '../../style.scss';
import { CONDITION, dataDefaulFilterList, generateColumnsFromCodesAgGridReactGroup, GROUPTYPE, IDataFilterGroupList, IInforAddGroup, ILastIdGroupCustomer, ISelectedCustomer, } from '../AddGroup/AddNewGroup';
import { ISelectedUserAccount } from '../EditGroup/ConditionEdit/EG_Decentralization';
import CG_PrivateNoAutomatic from './Component/CG_PrivateNoAutomatic';
import CG_SharingNoAutomatic from './Component/CG_SharingNoAutomatic';
import { NO_DATA, NO_VIEW } from '../../../../../services/data';
import { selectorInfoUser } from '../../../../../store/slices/infoUserSlice';
import { getLastIdList } from '../../../../../until';
import { selectorCategoryCarIds } from '../../../../../store/slices/categoryCarSlice';
import { BATCH_SIZE } from '../../../../../env';
import { ColDef } from 'ag-grid-community';
dayjs.locale('vi');



const initinforCombineGroup: IInforAddGroup = {
  title: "",
  type: 0,
  status: 0,
  unitScopeId: null,
  level: undefined,
  parentId: undefined,
  description: undefined
};


//--------------------

interface Props {
}


const CombineGroup: React.FC<Props> = ({
}) => {
  useEffect(() => {

    return () => {
    }
  }, [])

  const pushLoading = useLoading()
  const pushToast = useToast();
  const navigator = useNavigate()
  const { unitTemp } = useSelector(selectorInfoUser)
  const permittedCategoryCarIds = useSelector(selectorCategoryCarIds)

  const {
    displayType, inforNodeEvent, itemCombineGroup,
    dataFieldsActive,
    ColumnsMapShow,
    setInforNodeEvent,
    onSubmitFormCombine
  } = useCustomerGroupContext();

  const [pagination, setPagination] = useState({ current: 1, pageSize: 10, total: 0 });

  const [dataFilterList, setDataFilterList] = useState<IDataFilterGroupList>(dataDefaulFilterList)

  const [inforCombineGroup, setInforCombineGroup] = useState<IInforAddGroup>(initinforCombineGroup)

  const [selectedIdCustomerV9, setSelectedIdCustomerV9] = useState<ISelectedCustomer[]>([]);
  const [listUserSelectedAccount, setListUserSelectedAccount] = useState<ISelectedUserAccount[]>([]);

  const [lastId, setLastId] = useState<ILastIdGroupCustomer>()

  const [listCustomerNoAutomatic, setlistCustomerNoAutomatic] = useState<any[]>([])

  const tableDataCustomerNoAutomatic: any[] = useMemo(() => {
    return listCustomerNoAutomatic.map((item) => {
      const fieldValues = item.fields.reduce((acc: Record<string, any>, field: any) => {
        acc[field.fieldCode] = field.view ? field.value : NO_VIEW
        return acc
      }, {})
      return {
        ...item,
        key: item.id.toString(),
        ...fieldValues,
      }
    })
  }, [listCustomerNoAutomatic])

  const actionColumn: ColDef = {
    headerName: 'Nguồn',
    width: 110,
    resizable: false,
    pinned: 'left',
    suppressMovable: true,
    lockPosition: 'left',
    cellRenderer: (params: any) => {
      return !params.data.addType ?
        <div
          style={{
            height: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-start'
          }}
        >
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              borderRadius: '8px',
              height: '30px',
              padding: '2px 8px',
              backgroundColor: '#F6FFED',
              color: '#52C41A',
              border: '1px solid #52C41A',
              fontSize: 14
            }}
          >

            <span>Thủ công</span>
          </div>
        </div >

        :

        <div
          style={{
            height: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-start'
          }}
        >
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              borderRadius: '8px',
              height: '30px',
              padding: '2px 8px',
              backgroundColor: '#E6F7FF',
              color: '#40A9FF',
              border: '1px solid #40A9FF',
              fontSize: 14
            }}
          >

            <span>Điều kiện</span>
          </div>
        </div >
    }

  }

  const memoizedColumnDefs = useMemo(() => {
    return generateColumnsFromCodesAgGridReactGroup(
      ColumnsMapShow, dataFieldsActive, actionColumn,
      (id: number, next: boolean, rowData: any) =>
        navigator(
          `/customer/list/edit`,
          {
            state: {
              firstPage: "/customer/group",
              id: rowData?.data?.id,
              // inforNodeEvent: {
              //     ...inforNodeEvent,
              //     action: "view",
              // }
            }
          }
        )
    );
  }, [ColumnsMapShow, inforCombineGroup, listCustomerNoAutomatic]);

  const gListCustomerNoAutomatic = useDebounce(async (pageCurent: number = 1, pageSize: number = 20) => {
    pushLoading(true)
    const {
      listCategoryCar, listUnit, search
    } = dataFilterList

    const lastIdTmp = pageCurent === 1 ? undefined : lastId

    const result = await getListCustomerByGroup(
      permittedCategoryCarIds,
      pageSize, pageCurent, search, unitTemp ?? undefined,
      listUnit, listCategoryCar, itemCombineGroup[0], undefined,
      itemCombineGroup[1], undefined, lastIdTmp?.noCond
    )
    if (result?.status) {
      setlistCustomerNoAutomatic(result.data)
      setPagination({ current: pageCurent, total: result.total, pageSize })

      setLastId({ ...lastId, noCond: getLastIdList(result.data) })
    } else {
      // pushToast(result?.message, "warning")

    }
    pushLoading(false)
  }, 1000)

  const gListAllCustomer = useDebounce(async () => {
    pushLoading(true)
    const result = await getListAllCustomer(
      permittedCategoryCarIds,
      unitTemp, undefined, itemCombineGroup[0], undefined,
      itemCombineGroup[1]
    )
    if (result?.status) {
      setSelectedIdCustomerV9(result.data);
      // end test

    } else {
      pushToast(result?.message, "warning")
    }
    pushLoading(false)
  }, 1000)

  const handleChange = (field: keyof IInforAddGroup, value: any) => {
    setInforCombineGroup({
      ...inforCombineGroup,
      [field]: value,
    });
  };

  const addCustomersInChunks = async (selectedIdCustomerV9: ISelectedCustomer[], idGroup: number) => {
    for (let i = 0; i < selectedIdCustomerV9.length; i += BATCH_SIZE) {
      const chunk = selectedIdCustomerV9.slice(i, i + BATCH_SIZE);

      let success = false;
      let retryCount = 0;

      while (!success) {
        try {
          await addCustomerByGroup(chunk, idGroup);
          success = true;
        } catch (error) {
          retryCount++;
          console.error(`Chunk ${i / BATCH_SIZE + 1} failed (retry ${retryCount})`, error);

          // delay trước khi retry
          await new Promise(r => setTimeout(r, 1000));
        }
      }

      // delay giữa các batch
      await new Promise(r => setTimeout(r, 50));
    }
  };

  const addGroup = useThrottle(async () => {
    if (!inforCombineGroup.title || inforCombineGroup.title.trim() === "") {
      onSubmitFormCombine(false, "Tên nhóm không được để trống"!)
      return;
    }
    const { title, status, type, description, parentId } = inforCombineGroup
    const unitTempTmp = unitTemp ?? undefined
    const level = inforNodeEvent?.item?.level
    const typeTmp = CONDITION.NO

    pushLoading(true)
    // Tạm ẩn do thiếu api
    const result = await addListGroup(
      title, typeTmp, status,
      unitTempTmp, level, parentId,
      description, listUserSelectedAccount,
    )

    // tài thêm api riêng để thêm customer vào nhóm sau khi đã tạo nhóm thành công, tránh trường hợp tạo nhóm thất bại do lỗi dữ liệu của 1 vài customer trong list nhưng vẫn tạo nhóm thành công
    if (result?.status) {
      await addCustomersInChunks(
        selectedIdCustomerV9, result.data.id
      )
      onSubmitFormCombine(true, result?.message)
    } else {
      onSubmitFormCombine(false, result?.message)
    }
    pushLoading(false)
  }, 1000)



  const cancelAddGroup = useThrottle(async () => {
    setInforNodeEvent(undefined)
    setSelectedIdCustomerV9([])
  }, 1000)


  const onPaginationChange: PaginationProps['onChange'] = (pageNumber, pageSize) => {
    setPagination((prev) => ({ ...prev, current: pageNumber, pageSize }))
    gListCustomerNoAutomatic(pageNumber, pageSize)
  }

  useEffect(() => {
    gListCustomerNoAutomatic()
  }, [dataFilterList, unitTemp])


  //khi thay đổi item chọn
  useEffect(() => {
    if (inforNodeEvent?.action === "delete") {
      return
    }
    const { key: idGroup, level, parentId, } = inforNodeEvent?.item || {};
    const idParentTmp = idGroup ? +idGroup : undefined
    setInforCombineGroup({
      title: "",
      type: 0,
      status: GROUPTYPE.PRIVATE,
      unitScopeId: unitTemp,
      level: level ?? undefined,
      parentId: idParentTmp,
      description: undefined,
    });

  }, [inforNodeEvent, unitTemp]);


  //khi thay đổi item chọn
  useEffect(() => {
    if (inforNodeEvent?.action !== "combine") return

    if (itemCombineGroup[0] && itemCombineGroup[1]) {
      gListAllCustomer()
    }


  }, [itemCombineGroup]);


  return (
    <div className={`custom-page-css w-full flex flex-col relative ${displayType === EDisplayGroupType.TREE ? 'py-3 pr-3 pl-1' : ''} `}>
      <div className="custom-page-css w-full flex flex-col gap-2 bg-white p-4  rounded">
        <div className="custom-page-css w-full flex items-center justify-between">
          <div className="custom-page-css w-full flex items-center gap-2 ">
            <span className='custom-page-css text-base font-regular w-100px'>Loại nhóm</span>
            <div className={`${inforCombineGroup.status === GROUPTYPE.PRIVATE ? 'border-91D5FF bg-E6F7FF' : 'border'} custom-page-css flex items-center gap-2 rounded px-2 py-1 cursor-pointer`}
              onClick={() => handleChange("status", GROUPTYPE.PRIVATE)}>
              <div className="custom-page-css flex items-center justify-center">
                <img src={inforCombineGroup.status === GROUPTYPE.PRIVATE ? user_private_active : user_private} alt="" />
              </div>
              <span
                className={`${inforCombineGroup.status === GROUPTYPE.PRIVATE ? 'text-1890FF' : 'text-98A2B3'} custom-page-css text-base  font-regular`}
              >
                Nhóm riêng tư
              </span>
            </div>
            <div
              className={`${inforCombineGroup.status === GROUPTYPE.SHARED ? 'border-91D5FF bg-E6F7FF' : 'border'} custom-page-css flex items-center gap-2 rounded px-2 py-1 cursor-pointer`}
              onClick={() => handleChange("status", GROUPTYPE.SHARED)}>
              <div className="custom-page-css flex items-center justify-center">
                <img src={inforCombineGroup.status === GROUPTYPE.SHARED ? group_share_active : group_share} alt="" />
              </div>
              <span
                className={`${inforCombineGroup.status === GROUPTYPE.SHARED ? 'text-1890FF' : 'text-98A2B3'} custom-page-css text-base  font-regular`}
              >
                Nhóm có thể chia sẻ
              </span>
            </div>
          </div>
        </div>
        <div className="custom-page-css w-full flex items-center gap-2 ">
          <span className='custom-page-css text-base font-regular w-100px'>Tên nhóm</span>
          <div className={` custom-page-css flex items-center gap-2 border rounded px-2 py-1 cursor-pointer`}>
            <input
              placeholder='Nhập tên nhóm'
              className='custom-page-css outline-none border-none '
              value={inforCombineGroup?.title}
              onChange={(e) => handleChange("title", e.target.value)}
            />
          </div>

        </div>
        <div className="custom-page-css w-full flex items-start gap-2 ">
          <span className='custom-page-css text-base font-regular w-100px shrink-0'>Mô tả</span>
          <TextArea
            placeholder='Nhập mô tả'
            className='custom-page-css w-full  '
            value={inforCombineGroup?.description}
            onChange={(e) => handleChange("description", e.target.value)}
          />

        </div>
      </div>

      {/* Ẩn hiện component thêm nhóm Riêng tư  */}
      <div className={(inforCombineGroup.status === GROUPTYPE.PRIVATE && inforCombineGroup.type === CONDITION.NO) ? '' : 'd-none'}>
        <CG_PrivateNoAutomatic
          memoizedColumnDefs={memoizedColumnDefs}
          listCustomerNoAutomatic={tableDataCustomerNoAutomatic}

          pagination={pagination}
          dataFilterList={dataFilterList}

          inforAddGroup={inforCombineGroup}
          selectedIdCustomerV9={selectedIdCustomerV9}

          setDataFilterList={setDataFilterList}
          onPaginationChange={onPaginationChange}
        />
      </div>

      {/* Ẩn hiện component thêm nhóm có thể chia sẻ  */}
      <div className={(inforCombineGroup.status === GROUPTYPE.SHARED && inforCombineGroup.type === CONDITION.NO) ? '' : 'd-none'}>
        <CG_SharingNoAutomatic
          memoizedColumnDefs={memoizedColumnDefs}
          listCustomerNoAutomatic={tableDataCustomerNoAutomatic}

          pagination={pagination}
          dataFilterList={dataFilterList}
          inforAddGroup={inforCombineGroup}
          selectedIdCustomerV9={selectedIdCustomerV9}
          listUserSelectedAccount={listUserSelectedAccount}


          setDataFilterList={setDataFilterList}
          setListUserSelectedAccount={setListUserSelectedAccount}
          onPaginationChange={onPaginationChange}

        />
      </div>

      <div className="custom-page-css w-full flex items-center justify-end gap-2">
        <div className={` border-F5222D bg-FFF1F0 custom-page-css flex items-center gap-2 rounded px-2 py-1 cursor-pointer`}
          onClick={cancelAddGroup}
        >
          <CloseOutlined className='text-F5222D' />
          <span className={` custom-page-css text-F5222D text-base  font-regular`}>Huỷ bỏ</span>
        </div>
        <div className={`${inforCombineGroup.type === GROUPTYPE.SHARED ? '' : 'bg-096DD9'}  border-096DD9 custom-page-css flex items-center gap-2 rounded px-2 py-1 cursor-pointer`}
          onClick={() => addGroup(false)}
        >
          {
            inforCombineGroup.type === GROUPTYPE.SHARED ?
              <DownloadOutlined className='custom-page-css text-096DD9' /> :
              <CheckOutlined className='text-white' />}


          <span className={`${inforCombineGroup.type === GROUPTYPE.SHARED ? 'text-096DD9' : 'text-white'} custom-page-css  text-base  font-regular`}>
            Lưu nhóm
          </span>
        </div>


      </div>
    </div>
  )
}
export default React.memo(CombineGroup)
